import { render, staticRenderFns } from "./GridMenuLabels.vue?vue&type=template&id=70bd1372&"
import script from "./GridMenuLabels.vue?vue&type=script&lang=js&"
export * from "./GridMenuLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports